/**
 * Core global entry.
 */

// Runtime support for compiled/transpiled async functions
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// JS Component Framework and component configurations.
import { ComponentManager } from 'js-component-framework';
import headerConfig from 'components/header';
import articleListCarouselConfig from 'components/article-list-carousel';
import articleListTabsConfig from 'components/article-list-tabs';
import photoGalleryCarouselConfig from 'components/photo-gallery-carousel';
import modalConfig from 'components/modal';
import dropzoneWidgetConfig from 'components/dropzone-widget';

// React component manager and React components.
import reactComponentManager from 'utils/reactComponentManager';
import AlertBanners from 'components-react/alert-banners';
import AnvatoVideoPlayer from 'components-react/anvato-video-player';
import ArticleListInfinite from 'components-react/article-list-infinite';
import WeatherAlertsDetail from 'components-react/weather-alerts-detail';

// Global data store.
import store from 'redux/store';
import { supplyStore } from 'redux/share-store';
import withProvider from 'redux/with-provider';

// Template variables.
import { updateTemplateVariables } from 'redux/modules/template-variables';

// Components with styles.
import 'components/footer';
import 'components/article-list';
import 'components/ad-unit';
import 'components/headshot-list';
import 'components/page-header';
import 'components/static-link-bar';
import 'components/weather-radar';
import 'components/social-links';
import 'components/taboola';
import 'components/anvato-live-stream-widget';
import 'components/branded-logo';
import 'components/gallery';
import 'components/article-bin-carousel';
import 'parent/components/retrans';
import 'components/election-navigation';
import 'components/html-sitemap';

// Import SCSS.
import 'scss/index.scss';

// Additional scripts.
import domContentLoaded from 'utils/domContentLoaded';
import 'gtm-datalayer';

/*
 * Initialize JS Framework and React components.
 */

/**
 * JS Component Framework configs to be initialized.
 *
 * @type array
 */
const componentConfigs = [
  headerConfig,
  articleListCarouselConfig,
  articleListTabsConfig,
  photoGalleryCarouselConfig,
  modalConfig,
  dropzoneWidgetConfig,
];

/**
 * React components to be initialized by the reactComponentManager.
 *
 * Components that are initialized here can be wrapped in the Redux store
 * <Provider> here rather than individually within each component.
 *
 * @type object
 */

const componentManager = new ComponentManager('nexstar');
const initComponents = () => {
  componentManager.initComponents(componentConfigs);
  reactComponentManager({
    AlertBanners: withProvider(AlertBanners),
    AnvatoVideoPlayer: withProvider(AnvatoVideoPlayer),
    ArticleListInfinite,
    WeatherAlertsDetail,
  });
};

// Initialize components.
domContentLoaded(() => {
  initComponents();
});

// re-initialize react components when ReactComponentAdded event is fired
document.addEventListener('ReactComponentAdded', initComponents);

if (module.hot) {
  module.hot.accept();
  // This is required for HMR.
  initComponents();
}

// Pass the global store to other scripts that ask for it.
supplyStore(store);

/*
 * Set the global store of template variables.
 */
store.dispatch(updateTemplateVariables());
